/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */
import React from "react";

export const ErrorMessage = (props: {error: any}) => {
    return (
        <div className="container m-5 d-flex justify-content-center" style={{ height: 550 }}>
            <p>{props.error}</p>
        </div>
    );
}